<template>
  <refonte-modal
    v-bind:show="props.show_modal"
    v-on:close="props.onclose"
    v-bind:title="
      props.contrat?.typeContrat + ' - ' + props.contrat?.contratReference
    "
    class="!max-w-[720px]">
    <template v-slot:modalBody>
      <refonte-label v-bind:label="props.contrat?.periode" />
      <div class="refonte-item-file">
        <div class="item-file-content-left">
          <div class="item-file-content-title">
            <div class="item-file-content-title-text">
              <div class="item-file-content-title-text-top">
                {{
                  props.contrat?.typeContrat === 'Contrat'
                    ? 'Contrat formateur'
                    : 'Avenant'
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="item-file-content-middle">
          <div class="item-file-content-status">
            <div
              v-bind:class="`item-file-content-status-text ${
                !props.contrat?.documentASigner
                  ? 'text-jinius-blue'
                  : props.contrat?.fichierSigneDisponible
                    ? 'text-jinius-green'
                    : 'text-refonte-secondary'
              }`">
              <div class="item-file-content-status-text-icon">
                <IconValidate
                  v-if="!props.contrat?.documentASigner"
                  class="text-jinius-green" />

                <IconValidate20Green
                  v-else-if="
                    props.contrat?.fichierSigneDisponible &&
                    props.contrat?.documentASigner
                  "
                  class="text-jinius-green" />

                <IconTime
                  v-else
                  class="text-refonte-secondary" />
              </div>
              <span> {{ props.contrat?.statut }} </span>
            </div>
          </div>
        </div>
        <div class="item-file-content-right">
          <template v-if="!props.contrat?.documentASigner">
            <refonte-button
              class="item-file-content-sign"
              variant="secondary"
              v-bind:icon_left="IconDownload"
              v-on:click="
                props.download_contrat(
                  props.contrat?.id,
                  '',
                  props.contrat?.fichierRefNom
                )
              ">
              Télécharger
            </refonte-button>
          </template>
          <template v-else>
            <template
              v-if="
                props.contrat?.fichierDisponible &&
                props.contrat.typeSignatureId == null
              ">
              <refonte-button
                class="item-file-content-download"
                variant="secondary"
                v-bind:icon_left="IconDownload"
                v-on:click="
                  props.download_contrat(
                    props.contrat.id,
                    props.contrat.fichierSigneDisponible ? 'signe' : '',
                    props.contrat.fichierRefNom
                  )
                "
                v-tooltip="
                  props.contrat.fichierSigneDisponible
                    ? 'Télécharger la version signée'
                    : 'Télécharger la version non signée'
                ">
              </refonte-button>
              <refonte-button
                v-if="props.contrat.typeSignatureId == null"
                class="item-file-content-sign"
                variant="secondary"
                v-bind:icon_left="IconOpenNewTab"
                v-on:click="sign">
                Signer électroniquement
              </refonte-button>
            </template>
            <template v-else>
              <refonte-button
                v-if="props.contrat?.fichierSigneDisponible"
                class="item-file-content-download"
                variant="secondary"
                v-bind:icon_left="IconDownload"
                description="la version signée"
                v-tooltip="'Télécharger la version signée'"
                v-on:click="
                  props.download_contrat(
                    props.contrat.id,
                    props.contrat.fichierSigneDisponible ? 'signe' : '',
                    props.contrat.fichierRefNom
                  )
                ">
              </refonte-button>
              <refonte-button
                v-if="props.contrat?.lancement || props.contrat?.signature"
                variant="secondary"
                v-bind:icon_left="IconPlusCircle"
                v-on:click="openModalDetails">
                Voir détails
              </refonte-button>
            </template>
          </template>
        </div>
      </div>
    </template>
  </refonte-modal>
  <contrat-signature-electronique
    v-bind:show_modal="showContratModal"
    v-bind:contrat="props.contrat"
    v-bind:onclose="closeContratModal"
    v-bind:download_contrat="downloadContrat"
    v-bind:cancel="closeContratModal"
    v-bind:formateur="info_formateur"
    v-bind:submit="submit"
    contrat_base_url="formateur/contrats"
    v-bind:refresh_session="fetchContrats" />
  <refonte-modal-lancement-signature-formateur-success
    v-bind:show="isConfirmationActionDoneModalOpen"
    v-bind:type_contrat="contrat?.typeContrat"
    v-bind:on_close="closeConfirmationActionDoneModal"
    v-bind:formateur="info_formateur" />
  <refonte-modal-file-signature-details-in-progress
    v-bind:show="isDetailsInProgressModalOpen"
    v-bind:on_close="closeInProgressModal"
    v-bind:contrat="props.contrat"
    v-bind:formateur="info_formateur"
    v-bind:refresh_contrats="fetchContrats" />
  <refonte-modal-file-signature-details-signature-termine
    v-bind:show="isDetailsSignedModalOpen"
    v-bind:on_close="closeSignatureDoneModal"
    v-bind:contrat="props.contrat"
    v-bind:info_formateur="info_formateur" />
  <refonte-modal-file-signature-details-not-configured
    v-bind:show="isSignatureNotConfiguredModalOpen"
    v-bind:on_close="() => setIsSignatureNotConfiguredModalOpen(false)"
    v-bind:contrat="props.contrat" />
  <refonte-modal-file-signature-details-maintenance
    v-bind:show="isSignatureMaintenanceModalOpen"
    v-bind:on_close="() => setIsSignatureMaintenanceModalOpen(false)" />
  <refonte-modal-confirmation-action
    v-bind:show="isErrorModalOpen"
    v-bind:on_close="closeErrorModal"
    title="Erreur lors du lancement de la procédure"
    content="Une erreur est survenue lors du lancement de la procédure de signature. Veuillez réeesayer ultérieurement ou contacter votre administrateur." />
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';

  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import RefonteLabel from '@/components/refonte/inputs/refonte-label.vue';
  import IconDownload from '@/assets/img/refonte/icons/display/icon-download.svg?component';
  import IconOpenNewTab from '@/assets/img/refonte/icons/action/icon-open-new-tab.svg?component';
  import IconPlusCircle from '@/assets/img/refonte/icons/display/icon-plus-circle.svg?component';
  import IconValidate20Green from '@/assets/img/refonte/icons/information/icon-validate-20-green.svg?component';
  import IconTime from '@/assets/img/refonte/icons/information/icon-time.svg?component';
  import contratSignatureElectronique from './contrat-signature-electronique.vue';
  import refonteModalLancementSignatureFormateurSuccess from './refonte-modal-lancement-signature-formateur-success.vue';
  import refonteModalFileSignatureDetailsInProgress from './refonte-modal-file-signature-details-in-progress.vue';
  import refonteModalFileSignatureDetailsSignatureTermine from './refonte-modal-file-signature-details-signature-termine.vue';
  import refonteModalFileSignatureDetailsNotConfigured from './refonte-modal-file-signature-details-not-configured.vue';
  import RefonteModalFileSignatureDetailsMaintenance from '@/components/refonte/modals/refonte-modal-file-signature-details-maintenance.vue';
  import { API } from '@/http-common';
  import { FormateurContrat } from '@/types/formateur/formateur-contrat';
  import RefonteModalConfirmationAction from '@/components/refonte/modals/refonte-modal-confirmation-action.vue';
  import IconValidate from '@/assets/img/refonte/icons/information/icon-validate-20.svg?component';
  import { InfoFormateurSignature } from '@/types/formateur/info-formateur-signature';

  const props = defineProps<{
    show_modal: boolean;
    contrat?: FormateurContrat;
    info_formateur: InfoFormateurSignature;

    onclose: () => void;
    refresh_session: () => void;
    contrat_base_url: string;

    download_contrat: (
      id: FormateurContrat['id'],
      arg2: string,
      filename?: string
    ) => void;

    on_click_download?: () => void;
  }>();

  const showContratModal = ref(false);
  const isConfirmationActionDoneModalOpen = ref<boolean>(false);
  const isDetailsInProgressModalOpen = ref<boolean>(false);
  const isSignatureNotConfiguredModalOpen = ref<boolean>(false);
  const isSignatureMaintenanceModalOpen = ref<boolean>(false);

  function closeContratModal() {
    showContratModal.value = false;
  }

  function downloadContrat(
    id: FormateurContrat['id'],
    arg2 = '',
    filename?: string
  ) {
    return props.download_contrat(id, arg2, filename);
  }

  function fetchContrats() {
    return props.refresh_session();
  }
  const isErrorModalOpen = ref<boolean>(false);

  const closeErrorModal = () => {
    isErrorModalOpen.value = false;
    props.onclose();
  };
  const submit = async (): Promise<void> => {
    try {
      const response = await API.post(
        `formateur/contrat/${props.contrat?.id}/signature`,
        {},
        {
          headers: { 'SKIP-REDIRECTION': true }
        }
      );

      if (response.status === 200) {
        isConfirmationActionDoneModalOpen.value = true;
        fetchContrats();
      } else {
        isErrorModalOpen.value = true;
      }
    } catch (e) {
      isErrorModalOpen.value = true;
    }
  };

  const setIsDetailsInProgressModalOpen = (value: boolean) => {
    isDetailsInProgressModalOpen.value = value;
  };
  const signatureEnCours = computed(() => props.contrat?.statutId == 1);
  const isDetailsSignedModalOpen = ref<boolean>(false);

  const closeInProgressModal = async () => {
    await setIsDetailsInProgressModalOpen(false);
    props.onclose();
  };

  const setIsDetailsSignedModalOpen = (value: boolean) => {
    isDetailsSignedModalOpen.value = value;
  };

  const closeSignatureDoneModal = async () => {
    await setIsDetailsSignedModalOpen(false);
    props.onclose();
  };

  const openModalDetails = () => {
    if (signatureEnCours.value) {
      setIsDetailsInProgressModalOpen(true);
    } else if (props.contrat?.statutId == 2) {
      setIsDetailsSignedModalOpen(true);
    }
  };
  const closeConfirmationActionDoneModal = () => {
    isConfirmationActionDoneModalOpen.value = false;
    closeContratModal();
    props.onclose();
  };

  const setIsSignatureNotConfiguredModalOpen = (value: boolean) => {
    isSignatureNotConfiguredModalOpen.value = value;
  };
  const setIsSignatureMaintenanceModalOpen = (value: boolean) => {
    isSignatureMaintenanceModalOpen.value = value;
  };

  const sign = () => {
    if (props.contrat?.signatureNotConfigured) {
      setIsSignatureNotConfiguredModalOpen(true);
    } else if (props.contrat?.signatureMaintenance) {
      setIsSignatureMaintenanceModalOpen(true);
    } else {
      showContratModal.value = true;
    }
  };
</script>

<style lang="scss" scoped>
  .refonte-item-file {
    @apply flex flex-grow bg-refonte-pale-violet-2;
    gap: 4px;
    border-radius: 8px;
    padding: 6px 12px 6px 12px;
    max-width: 700px;
    width: 100%;
    min-height: 48px;

    .item-file-content-left {
      @apply flex items-center;
      gap: 4px;
      width: 30%;
      .item-file-content-title {
        @apply flex flex-grow items-start;
        gap: 2px;

        .item-file-content-title-text {
          @apply flex flex-grow flex-col items-start;
          gap: 2px;

          .item-file-content-title-text-top {
            @apply self-stretch overflow-hidden text-ellipsis text-refonte-black;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            font-size: 13px;
            font-weight: 400;
            line-height: 16px;
          }
          .item-file-content-title-text-bottom {
            @apply self-stretch overflow-hidden text-ellipsis text-refonte-black-40;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            font-size: 12px;
            font-weight: 400;
            line-height: 14px;
          }
        }
      }
    }
    .item-file-content-middle {
      @apply flex items-center;
      width: 30%;
      gap: 4px;

      .item-file-content-status {
        @apply flex flex-grow items-center;
        gap: 4px;

        .item-file-content-status-text {
          @apply flex flex-grow items-center;
          gap: 2px;
          margin-right: 6px;

          .item-file-content-status-text-icon {
            @apply flex shrink-0 items-center justify-center;
            width: 20px;
            height: 20px;

            :deep(svg) {
              width: 18px;
              height: 18px;
            }
          }

          span {
            @apply whitespace-nowrap;
            font-size: 13px;
            line-height: 16px;
            font-weight: 400;
          }
        }
      }
    }
    .item-file-content-right {
      @apply flex justify-end;
      width: 40%;
      gap: 6px;

      .item-file-content-download {
        gap: 2px;
      }
      .item-file-content-sign {
        gap: 8px;
      }
    }

    @media (max-width: 515.98px) {
      @apply flex-col items-stretch;

      .item-file-content-left {
        max-width: 100%;

        .item-file-content-download-separator {
          @apply hidden;
        }
      }
    }
  }
</style>
